export default __webpack_public_path__ + "static/media/mail.6f33e76e.png";